module.exports = __webpack_public_path__ + "img/rankbg.435d51ed.png";